var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortByIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrows") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#009745",
    points: "14.411072 16.666015 9.65515 11.910093 10.833662 10.731582 13.583498 13.481419 13.583498 3.332682 15.250165 3.332682 15.250165 13.4699 17.988483 10.731582 19.166994 11.910093"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#009745",
    points: "5.589585 3.332682 10.345507 8.088604 9.166996 9.267115 6.417158 6.517278 6.417159 16.666014 4.750491 16.666015 4.750491 6.528797 2.012175 9.267115 0.833662 8.088606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortByIcon);
export default __webpack_public_path__ + "static/media/sortByIcon.c5f99df1e82477d9a2a35c74d4fb0574.svg";
export { ForwardRef as ReactComponent };